export default __webpack_public_path__ + "static/DSC_0178-50d6c50a6acd6312f53ab6186bd190ad.jpg";